module.exports = __webpack_public_path__ + "static/media/NewLogo.b83c14c1.svg";